import { urlConfig } from "../../config/urlConfig";
import {
  FileLocationContextModel,
  FileLocationModel,
} from "../../types/FileLocationModel";
import { postCall, postFileDownloadCall } from "../httpService";

export const GetFileLocationData = async (params: FileLocationModel) => {
  try {
    const response = await postCall(urlConfig.FileLocationDetails, params);
    return response.data;
  } catch (error) {
    console.error("Error in File Location Data fetching", error);
    throw error;
  }
};

export const DownloadExcel = async (params: any) => {
  try {
    const response = await postFileDownloadCall(urlConfig.ExportExcel, params);
    return response;
  } catch (error) {
    console.error("Error in DownloadEmailTemplate", error);
    throw error;
  }
};

export const GetFileLocationDataById = async (params: FileLocationModel) => {
  try {
    const response = await postCall(urlConfig.FileLocationDetailsById, params);
    return response.data;
  } catch (error) {
    console.error("Error in File Location Data fetching", error);
    throw error;
  }
};

export const DeleteFileLocationById = async (params: FileLocationModel) => {
  try {
    const response = await postCall(urlConfig.DeleteFileLocationById, params);
    return response.data;
  } catch (error) {
    console.error("Error in File Location Data fetching", error);
    throw error;
  }
};

export const SaveFileLocationData = async (
  params: FileLocationContextModel
) => {
  try {
    const response = await postCall(urlConfig.CreateNew, params);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error("Error in File Location Data fetching", error);
    throw error;
  }
};
